export function Logo({ size = 36, showText = true, light = false }) {
  // `light` = rendered on a dark background (use the white+red variant)
  const src = showText
    ? light
      ? "/logo-full-light.png"
      : "/logo-full-dark.png"
    : light
      ? "/logo-mark-light.png"
      : "/logo-mark-dark.png";
  return (
    <div className="flex items-center select-none" data-testid="cricktrack-logo">
      <img
        src={src}
        alt="CrickTrack"
        style={{ height: showText ? size * 1.35 : size, width: "auto" }}
        className="block object-contain"
        draggable={false}
      />
    </div>
  );
}
